'use strict';

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

import AdapterRegistry from './adapterRegistry';
import UtilityRegistry from './utilityRegistry';
export var LocalRegistry = function LocalRegistry() {
  _classCallCheck(this, LocalRegistry);
  /*
       Creates both utility and adapter registry, both mounted on global.registry
      You can access these like this:
       global.registry.registerAdapter()
      global.registry.registerUtility()
      ...
   */


  var registry = new UtilityRegistry();
  var tmp = new AdapterRegistry();
  Object.keys(tmp).forEach(function (key) {
    if (tmp.hasOwnProperty(key)) {
      registry[key] = tmp[key];
    }
  });
  registry['registerAdapter'] = tmp.registerAdapter;
  registry['getAdapter'] = tmp.getAdapter;
  return registry;
};